<div class="px-2 pt-1 pb-4 bg-white shadow-md h-full rounded-md transform text-brand-secondary relative">
    <div *ngIf="heading" class="text-left text-sm p-2 text-brand-primary font-bold">
        {{heading}}
    </div>
    <ng-content></ng-content>
</div>